function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), /*#__PURE__*/React.createElement("g", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "1.5",
  clipPath: "url(#a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M21.004 21.004l-5.35-5.35m-2.306-12.05a7.414 7.414 0 104.478 6.807"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.001 9.002a3.001 3.001 0 013.001-3 3.001 3.001 0 01-3-3.002A3.001 3.001 0 0113 6.001a3.001 3.001 0 013.001 3.001z",
  clipRule: "evenodd"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M0 0h24v24H0z"
}))));